import React from 'react';
import { FeatherIcon, ArrowRightIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export function About() {
  return <div className="w-full" data-id="element-198">
      {/* Header */}
      <section className="cream-bg py-16 md:py-24 w-full" data-id="element-199">
        <div className="container mx-auto px-4" data-id="element-200">
          <div className="max-w-3xl mx-auto text-center" data-id="element-201">
            <div className="flex justify-center mb-6" data-id="element-202">
              <FeatherIcon size={40} className="accent-color" data-id="element-203" />
            </div>
            <h1 className="text-4xl md:text-5xl font-bold mb-6 elegant-heading" data-id="element-204">
              Home of Stories That Boil The Ocean
            </h1>
          </div>
        </div>
      </section>
      {/* About Content */}
      <section className="py-16 w-full bg-white" data-id="element-205">
        <div className="container mx-auto px-4" data-id="element-206">
          <div className="max-w-3xl mx-auto" data-id="element-207">
            <p className="text-lg mb-6 navy-text" data-id="element-208">
              Muthamia Content is a Nairobi-based creative studio specializing
              in native-style brand storytelling and strategic content
              development.
            </p>
            <p className="text-lg mb-6 navy-text" data-id="element-209">
              We help corporations, businesses, institutions, media platforms,
              and visionary brands communicate clearly, boldly, and
              authentically.
            </p>
            <div className="elegant-divider" data-id="element-210"></div>
            <p className="text-lg mb-6" data-id="element-211">
              Founded on the belief that content should connect - not just exist
              - we bring a unique blend of streetwise intuition, strategic
              depth, and editorial sharpness to every project.
            </p>
            <p className="text-lg mb-6" data-id="element-212">
              Our team is made up of creative writers, seasoned campaign
              strategists, and digital natives who understand the rhythm of the
              Kenyan audience.
            </p>
            <p className="text-lg mb-12" data-id="element-213">
              Whether we're scripting a product launch, building a blog series,
              or executing a full advertising campaign, we do it with the same
              principle:
            </p>
            <div className="gold-gradient text-white p-8 rounded-lg text-center mb-12 elegant-card" data-id="element-214">
              <h3 className="text-2xl md:text-3xl font-bold" data-id="element-215">
                Tell a story that will boil the ocean.
              </h3>
            </div>
            <div className="mt-16 text-center" data-id="element-216">
              <h2 className="text-2xl font-bold mb-8 elegant-heading" data-id="element-217">
                Explore Our Published Work
              </h2>
              <Link to="/portfolio" className="inline-flex items-center justify-center px-8 py-4 accent-bg text-white rounded-md hover:bg-opacity-90 transition-colors" data-id="element-218">
                <span data-id="element-219">View our portfolio</span>
                <ArrowRightIcon size={18} className="ml-2" data-id="element-220" />
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>;
}